import LeaderBoard from './LeaderBoard';
export default LeaderBoard